const apiKey = {
    USER_ID: 'user_OdXOLJCOEnoWzvO2nOowr',
    TEMPLATE_ID: 'template_n949h6q',
    SERVICE_ID: 'service_1esrto6'
}

export default apiKey;